import React, {useRef, useEffect, useCallback,useContext} from "react";
import "react-toastify/dist/ReactToastify.css";
import Header from "./Header";
import { UserContext } from "../contexts/UserContext";
import Sidebar from "./Sidebar";
import useState from "react-usestateref";
import authService from "../services/authservices";
import PoolProgress from "./PoolProgress";
import { ScaleLoader } from 'react-spinners'


function Deposit() {
  const { theme } = useContext(UserContext);


  const [loading, setLoading] = useState(false);
   const [pool1Data, setpool1Data] = useState("");
   const [pool2Data, setpool2Data] = useState("");
   const [pool3Data, setpool3Data] = useState("");
   const [pool4Data, setpool4Data] = useState("");

     const poolDetails = async () => {
         try {
          setLoading(true);
           const data = await authService.getPoolData();
           console.log("pool data====",data.data.pool1_resp);
           if (data && data.status) {
             setLoading(false);
             let data1 = [
               { label: "Direct Referral Count", current: data.data.pool1_resp.referral_count_current, goal: data.data.pool1_resp.referral_count_goal, color: "#10b981" }, // Green
               { label: "Total Team", current: data.data.pool1_resp.teamsize_current, goal: data.data.pool1_resp.teamsize_goal, color: "#ef4444" }, // Red
               { label: "Total Team Deposit", current: data.data.pool1_resp.teamdeposit_current, goal: data.data.pool1_resp.teamdeposit_goal, color: "#3b82f6" }, // Blue
             ];
             setpool1Data(data1);


             let data2 = [
               { label: "Direct Referral Count", current: data.data.pool2_resp.referral_count_current, goal: data.data.pool2_resp.referral_count_goal, color: "#10b981" }, // Green
               { label: "Total Team", current: data.data.pool2_resp.teamsize_current, goal: data.data.pool2_resp.teamsize_goal, color: "#ef4444" }, // Red
               { label: "Total Team Deposit", current: data.data.pool2_resp.teamdeposit_current, goal: data.data.pool2_resp.teamdeposit_goal, color: "#3b82f6" }, // Blue
             ];
             setpool2Data(data2);

             let data3 = [
               { label: "Direct Referral Count", current: data.data.pool3_resp.referral_count_current, goal: data.data.pool3_resp.referral_count_goal, color: "#10b981" }, // Green
               { label: "Total Team", current: data.data.pool3_resp.teamsize_current, goal: data.data.pool3_resp.teamsize_goal, color: "#ef4444" }, // Red
               { label: "Total Team Deposit", current: data.data.pool3_resp.teamdeposit_current, goal: data.data.pool3_resp.teamdeposit_goal, color: "#3b82f6" }, // Blue
             ];
             setpool3Data(data3);

             let data4 = [
               { label: "Direct Referral Count", current: data.data.pool4_resp.referral_count_current, goal: data.data.pool4_resp.referral_count_goal, color: "#10b981" }, // Green
               { label: "Total Team", current: data.data.pool4_resp.teamsize_current, goal: data.data.pool4_resp.teamsize_goal, color: "#ef4444" }, // Red
               { label: "Total Team Deposit", current: data.data.pool4_resp.teamdeposit_current, goal: data.data.pool4_resp.teamdeposit_goal, color: "#3b82f6" }, // Blue
             ];
             setpool4Data(data4);
           } else {
              
           }
         } catch (error) {
             console.error('Error fetching user details:', error);
            
         }
         
       };
  

  // const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
          if (theme === 'dark') {
            document.body.classList.add('dark');
            document.body.classList.remove('light');
          } else {
            document.body.classList.add('light');
            document.body.classList.remove('dark');
          }
      
          localStorage.setItem('theme', theme);
        }, [theme])


        useEffect(() => {
          poolDetails();
        }, [0]);
  

    

  return (
    <div>
      <section>
        <Header />
      </section>

      <div className="deposit-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-2 dispaly_none_1200">
              <Sidebar />
            </div>
            <div className="col-xl-10 col-lg-12 deposit_pad_top">
              

            <div className="p-6">
            <span className="profile_span">Pool Progress</span>

       {/* Grid container for pools */}
       {loading==true ? (
       <div className="loader_main loader_mainChange">
           <ScaleLoader color="#20A1FD" height={10} width={3} />
           <p>Loading...</p>
       </div>
       ) : (
       <div className="pools-grid">
         <div className="pool-card">
           <h2 className="text-lg font-semibold mb-4">Pool 1 Progress</h2>
           <PoolProgress data={pool1Data} />
         </div>

         <div className="pool-card">
           <h2 className="text-lg font-semibold mb-4">Pool 2 Progress</h2>
           <PoolProgress data={pool2Data} />
         </div>

         <div className="pool-card">
           <h2 className="text-lg font-semibold mb-4">Pool 3 Progress</h2>
           <PoolProgress data={pool3Data} />
         </div>

         <div className="pool-card">
           <h2 className="text-lg font-semibold mb-4">Pool 4 Progress</h2>
           <PoolProgress data={pool4Data} />
         </div>
       </div>
       )}
     </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Deposit;

